module.exports = __webpack_public_path__ + "static/media/TipoDoc5.ed0aa0ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/CadTipoDoc/TipoDoc5.png
// module id = 2194
// module chunks = 0